/* [DC] - 28th Sep 2026 - Selleasy PDP addon widget hooks.
   Loaded from layout/theme.liquid on product pages only.
   Changes what the PDP addon widget displays - cart, checkout
   and orders keep the full product title.
   Both maps match the product name exactly as Selleasy renders it.
   If a product title changes in Shopify, its entry quietly stops
   applying (the widget shows the real title) until updated here.
   Prices are reformatted to match snippets/product-price.liquid:
   no trailing .00, commas dropped under $10,000, superscript $ and cents.
   [DC] - 13th Oct 2026 - PM state dropdown opens on an inert
   "Select Service State" option. The PM card can't be selected until a
   real state is chosen, so PM is never added with a default state.
   Styling lives in assets/custom.css (.vcs-addon-note, .vcs-price-sup);
   the state message reuses .vcs-addon-note. */
(function () {
    // Full product title -> name shown in the widget
  var RENAMES = {
    'Espresso Machine Preventative Maintenance Annual Plan':
      'Preventative Maintenance Annual Plan'
  };

  // Full product title -> note shown under the price
  // Warranties that include the PM plan. Simonelli has no warranty offer;
  // the La Spaziale labor warranty does not include PM, so it gets no note.
  var NOTES = {
    'La Marzocco Commercial Extended Warranty': 'Includes Preventative Maintenance Annual Plan',
    'Sanremo Commercial Extended Warranty': 'Includes Preventative Maintenance Annual Plan',
    'Synesso Commercial Extended Warranty': 'Includes Preventative Maintenance Annual Plan',
    'Slayer Commercial Extended Warranty': 'Includes Preventative Maintenance Annual Plan',
    'Schaerer Commercial Extended Warranty': 'Includes Preventative Maintenance Annual Plan'
  };

  // PM state dropdown - first option and the message shown if the
  // customer selects the PM card before choosing a state
  var STATE_PLACEHOLDER = 'Select Service State';
  var STATE_MESSAGE = 'Choose your service state to add this plan.';

  var WIDGET = 'lb-upsell-product-page-addon';
  var NOTE_CLASS = 'vcs-addon-note';
  var STATE_SELECT = 'select.lb-shared-variants-select';
  var STATE_MSG_CLASS = 'vcs-state-msg';
  var PLACEHOLDER_ATTR = 'data-vcs-placeholder';
  var chosenState = null; // last real state the customer picked

  function has(map, key) {
    return Object.prototype.hasOwnProperty.call(map, key);
  }

  var PRICE_ATTR = 'data-vcs-price';

  // Mirrors snippets/product-price.liquid:
  // money_without_trailing_zeros, remove ',' when price <= 999999 cents,
  // superscript currency symbol and cents.
  function formatPrice(el) {
    var current = el.textContent.trim();
    if (el.getAttribute(PRICE_ATTR) === current) return; // already ours
    var m = current.match(/^([^\d]*)([\d,]+)(?:\.(\d{2}))?$/);
    if (!m) return; // unexpected format - leave Selleasy's text alone
    var symbol = m[1];
    var dollars = m[2];
    var cents = m[3] || '00';
    var priceInCents = parseInt(dollars.replace(/,/g, '') + cents, 10);
    if (priceInCents <= 999999) dollars = dollars.replace(/,/g, '');

    while (el.firstChild) el.removeChild(el.firstChild);
    if (symbol) {
      var sup = document.createElement('span');
      sup.className = 'vcs-price-sup vcs-price-cur';
      sup.textContent = symbol;
      el.appendChild(sup);
    }
    el.appendChild(document.createTextNode(dollars));
    if (cents !== '00') {
      var c = document.createElement('span');
      c.className = 'vcs-price-sup';
      c.textContent = cents;
      el.appendChild(c);
    }
    el.setAttribute(PRICE_ATTR, el.textContent.trim());
  }

  // A state counts as chosen only when the selected option is a real one
  function hasState(sel) {
    var o = sel.options[sel.selectedIndex];
    return !!(o && !o.disabled && o.value);
  }

  // Inert first option. Selleasy renders the option name ("State") as a
  // disabled first option - that one is relabelled rather than adding a
  // second. Shown until the customer picks a state; if Selleasy
  // re-renders the dropdown after that, their pick is restored.
  function addPlaceholder(sel) {
    var ph = sel.querySelector('option[' + PLACEHOLDER_ATTR + ']');
    if (!ph) {
      ph = sel.options[0] && sel.options[0].disabled ? sel.options[0] : null;
      if (!ph) {
        ph = document.createElement('option');
        ph.value = '';
        ph.disabled = true;
        sel.insertBefore(ph, sel.firstChild);
      }
      ph.setAttribute(PLACEHOLDER_ATTR, '1');
      if (ph.textContent !== STATE_PLACEHOLDER) ph.textContent = STATE_PLACEHOLDER;
      if (chosenState !== null) {
        sel.value = chosenState;
        if (sel.value === chosenState && hasState(sel)) return;
      }
      sel.selectedIndex = ph.index;
      return;
    }
    if (ph.textContent !== STATE_PLACEHOLDER) ph.textContent = STATE_PLACEHOLDER;
    // keep the placeholder showing until the customer chooses
    if (chosenState === null && sel.selectedIndex !== ph.index) sel.selectedIndex = ph.index;
  }

  // The PM card is the widget card that has the state dropdown
  function pmCard(el) {
    var card = el.closest && el.closest('.lb-spc-cont');
    if (!card || !card.closest(WIDGET)) return null;
    return card.querySelector(STATE_SELECT) ? card : null;
  }

  function showStateMessage(card) {
    if (card.querySelector('.' + STATE_MSG_CLASS)) return;
    var sel = card.querySelector(STATE_SELECT);
    var anchor = sel.closest('.lb-spc-details-btm') || sel;
    var msg = document.createElement('div');
    msg.className = NOTE_CLASS + ' ' + STATE_MSG_CLASS;
    msg.setAttribute('role', 'alert');
    msg.textContent = STATE_MESSAGE;
    anchor.insertAdjacentElement('afterend', msg);
  }

  function hideStateMessage(card) {
    var msg = card.querySelector('.' + STATE_MSG_CLASS);
    if (msg) msg.parentNode.removeChild(msg);
  }

  // Block selecting the PM card while the placeholder is showing.
  // Capture phase on window runs before Selleasy's own handlers, so a
  // blocked click never reaches them. Deselecting is always allowed.
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = pmCard(t);
    if (!card) return;
    if (t.closest('select, option, .lb-spc-details-variants')) return;
    var sel = card.querySelector(STATE_SELECT);
    if (hasState(sel)) return;
    // A click on the input itself has already toggled it by the time this
    // runs, so its current state is the new one; a click elsewhere on the
    // card hasn't toggled anything yet.
    var input = card.querySelector('.lb-spc-details-checkbox');
    var selecting = (t === input) ? input.checked : !(input && input.checked);
    if (!selecting) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showStateMessage(card);
    sel.focus();
  }, true);

  // Remember the customer's state and clear the message
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(WIDGET + ' ' + STATE_SELECT)) return;
    if (!hasState(t)) return;
    chosenState = t.value;
    var card = pmCard(t);
    if (card) hideStateMessage(card);
  }, true);

  function apply() {
    var prices = document.querySelectorAll(WIDGET + ' .lb-upsell-money-2');
    for (var p = 0; p < prices.length; p++) formatPrice(prices[p]);

    var selects = document.querySelectorAll(WIDGET + ' ' + STATE_SELECT);
    for (var s = 0; s < selects.length; s++) addPlaceholder(selects[s]);

    var names = document.querySelectorAll(WIDGET + ' .lb-spc-details-name');
    for (var i = 0; i < names.length; i++) {
      var nameEl = names[i];
      var title = nameEl.textContent.trim();

      // Note - added once per card, after the price
      if (has(NOTES, title)) {
        var details = nameEl.closest('.lb-spc-details-cont');
        var price = details && details.querySelector('.lb-spc-details-price-cont');
        if (price && !details.querySelector('.' + NOTE_CLASS)) {
          var note = document.createElement('div');
          note.className = NOTE_CLASS;
          note.textContent = NOTES[title];
          price.insertAdjacentElement('afterend', note);
        }
      }

      // Rename - once swapped, the text no longer matches, so it stops
      if (has(RENAMES, title)) {
        nameEl.textContent = RENAMES[title];
      }
    }
  }

  apply();
  new MutationObserver(apply).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();